import GlobalStateContext from "contexts/GlobalStateContext";
import { useContext } from "react";

export default function useConfirmDefaultAvailabilityChangesModal() {
  const { state, setState: updateGlobalState } = useContext(GlobalStateContext);

  const setState = (args) => {
    const newState = { ...state.updateConfirmDefaultAvailabilityChangesModalState, ...args };
    updateGlobalState({ updateConfirmDefaultAvailabilityChangesModalState: newState });
  };

  return {
    close: () => setState({ isOpen: false }),
    isOpen: state.updateConfirmDefaultAvailabilityChangesModalState.isOpen,
    open: () => setState({ isOpen: true }),
  };
}
